import toastr from 'toastr'

const components = {
}

const directives = {

}

const computed = {
  locationOccupancy() {
    return _.cloneDeep(this.$store.state.reports.locationOccupancy);
  } 
}

const methods = {
  displayErrors (errors) {
    this.$emit('checkinReportErrors',errors);
  }
}

export default {
  name: 'reports-location-occupancy',
  props: ['url'],
  computed,
  components,
  directives,
  methods,
  data () {
    return {
      processing: false,
      errors: {},
      rows: [],
      columns: []
    }
  },
  created () {

    this.processing = true;
    this.$store.dispatch('reports.getLocationOccupancy', this.url).then(() => {
      this.processing = false;
      if (this.$store.state.reports.errors) {
        toastr.error(this.$store.state.reports.errors.message);
      } else {
        this.columns = this.locationOccupancy.slice(0, 1)[0];
        this.rows = this.locationOccupancy.slice(1);
      }

    });
  },

  beforeDestroy () {
    this.$store.dispatch('reports.resetReports');
  }
}
